import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox, FormControlLabel, Tooltip } from '@material-ui/core';
import { Check, Info } from '@material-ui/icons';
import FormTextInput from 'components/FormTextInput/FormTextInput';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { toast } from 'react-toastify';

import Button from '../../../components/CustomButtons/Button';
import { post } from '../../../helpers/apiHelpers';

const GetResponseModule = ({ classes, handleModuleUpdate, module }) => {
  const { t } = useTranslation();
  const [isSyncing, setIsSyncing] = useState(false);
  const [isShowApiDomainGetResponse, setIsShowApiDomainGetResponse] = useState(
    !!module.apiDomain
  );

  const handleClientsSync = async () => {
    setIsSyncing(true);
    try {
      await post('/getresponse/client-sync');
      toast.success(
        t('brands.newBrandForm.thulium.syncContacts.successMessage')
      );

      setIsSyncing(false);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
    } catch (e) {
      setIsSyncing(false);
    }
  };

  if (!module) {
    return (
      <div>
        {t('brands.newBrandForm.moduleNotLoaded', {
          defaultValue: '{{moduleName}} not loaded.',
          replace: 'GetResponse',
        })}
      </div>
    );
  }

  // eslint-disable-next-line no-negated-condition -- FIXME
  return !module ? (
    <div>
      {t('brands.newBrandForm.moduleNotLoaded', {
        defaultValue: '{{moduleName}} not loaded.',
        // eslint-disable-next-line no-undef -- FIXME
        replace: { moduleName: __filename.split('.')[0] },
      })}
    </div>
  ) : (
    <>
      <GridContainer>
        <GridItem xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={module.enabled}
                // eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
                onChange={e =>
                  handleModuleUpdate({
                    ...module,
                    enabled: !module.enabled,
                  })
                }
                checkedIcon={<Check className={classes.checkedIcon} />}
                icon={<Check className={classes.uncheckedIcon} />}
                classes={{
                  checked: classes.checked,
                  root: classes.checkRoot,
                }}
              />
            }
            label={t(
              'brands.newBrandForm.useGetResponseLabel',
              'Używaj GetResponse.com'
            )}
          />

          <Button disabled={isSyncing} onClick={handleClientsSync}>
            {t('brands.newBrandForm.thulium.syncContacts', 'Synchronizuj')}
          </Button>
          <Tooltip
            title={t('brands.newBrandForm.thulium.syncContacts.tooltip')}
            placement="top"
          >
            <Info fontSize="small" style={{ color: 'gray' }} />
          </Tooltip>
        </GridItem>
        <GridItem xs={12}>
          <FormTextInput
            label={t('brands.newBrandForm.getResponse.apiKey', 'API klucz')}
            classes={classes}
            name="getResponseApiKey"
            value={module.apiKey}
            maxLength={64}
            handleChange={e =>
              handleModuleUpdate({
                ...module,
                apiKey: e.target.value,
              })
            }
            inputSize={12}
          />
        </GridItem>
        <GridItem style={{ display: 'flex' }} xs={12}>
          {/* eslint-disable-next-line no-negated-condition -- FIXME */}
          {!isShowApiDomainGetResponse ? (
            <FormControlLabel
              control={
                <Checkbox
                  checked={isShowApiDomainGetResponse}
                  onChange={() =>
                    setIsShowApiDomainGetResponse(!isShowApiDomainGetResponse)
                  }
                  checkedIcon={<Check className={classes.checkedIcon} />}
                  icon={<Check className={classes.uncheckedIcon} />}
                  classes={{
                    checked: classes.checked,
                    root: classes.checkRoot,
                  }}
                />
              }
              label={t(
                'brands.newBrandForm.getResponse.apiDomain.checkbox.description'
              )}
            />
          ) : (
            <FormTextInput
              label={
                <>
                  <span style={{ marginRight: '5px' }}>
                    {t(
                      'brands.newBrandForm.getResponse.apiDomain',
                      'API domena'
                    )}
                  </span>
                  <Tooltip
                    title={t(
                      'brands.newBrandForm.useGetResponse.apiDomain.tooltip'
                    )}
                    placement="top"
                  >
                    <Info fontSize="small" style={{ color: 'gray' }} />
                  </Tooltip>
                </>
              }
              classes={classes}
              name="getResponseApiDomain"
              value={module.apiDomain}
              maxLength={64}
              handleChange={e =>
                handleModuleUpdate({
                  ...module,
                  apiDomain: e.target.value,
                })
              }
              inputSize={12}
            />
          )}
        </GridItem>
      </GridContainer>
    </>
  );
};

export default GetResponseModule;
